<template>
  <div class="max-width">
    <v-card-title class="justify-center mb-2">{{
      $t("recover-password")
    }}</v-card-title>
    <v-form v-model="valid" ref="form" class="text-center">
      <EmailField @setFormValue="email = $event" />
      <v-btn
        @click="submit"
        :loading="false"
        color="indigo accent-4"
        min-width="280"
        dark
        rounded
        large
        >{{ $t("recover-action") }}</v-btn
      >
    </v-form>
    <div class="mt-6 pt-12"></div>
    <div class="text-center">
      <v-btn
        small
        rounded
        outlined
        color="indigo accent-4"
        @click="$store.dispatch('authentication/toStep', 'signin')"
        >{{ $t("to-signin") }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import EmailField from "./EmailField";
export default {
  components: { EmailField },
  data: () => ({
    name: "RecoverPassword",
    valid: true,
    email: ""
  }),
  methods: {
    submit() {}
  }
};
</script>

<style lang="scss" scoped>
.max-width {
  max-width: 360px;
  margin: 0 auto;
}
</style>
